export enum simulatorActionTypes {
  SET_SIMULATOR_DATA = 'SET_SIMULATOR_DATA',
  RESET_SIMULATOR_DATA = 'RESET_SIMULATOR_DATA',
  SET_APPLICATION_PREVIEW = 'SET_APPLICATION_PREVIEW',
}
